<section class="user-funnel-page">
  <app-admin-page-header [title]="title" [subtitle]="subtitle">
    <div header-actions class="user-funnel-page__meta">
      <span>{{ totalItems }} usuários</span>
    </div>
  </app-admin-page-header>

  <div class="user-funnel-toolbar admin-surface">
    <div class="user-funnel-toolbar__field user-funnel-toolbar__field--date">
      <label for="funnel-since">Data inicial</label>
      <p-datepicker
        inputId="funnel-since"
        dateFormat="dd/mm/yy"
        [(ngModel)]="since"
        [readonlyInput]="true"
        [appendTo]="'body'"
        (onClose)="onSinceChange()"></p-datepicker>
    </div>

    <div class="user-funnel-toolbar__field user-funnel-toolbar__field--date">
      <label for="funnel-until">Data final</label>
      <p-datepicker
        inputId="funnel-until"
        dateFormat="dd/mm/yy"
        [(ngModel)]="until"
        [readonlyInput]="true"
        [appendTo]="'body'"
        (onClose)="onUntilChange()"></p-datepicker>
    </div>

    <div class="user-funnel-toolbar__field">
      <label for="platform">Plataforma</label>
      <select id="platform" class="admin-input" [(ngModel)]="platform">
        <option *ngFor="let option of platformOptions" [value]="option.value">{{ option.label }}</option>
      </select>
    </div>

    <div class="user-funnel-toolbar__field">
      <label for="recurring">Compras recorrentes</label>
      <select id="recurring" class="admin-input" [(ngModel)]="recurring">
        <option *ngFor="let option of recurringOptions" [value]="option.value">{{ option.label }}</option>
      </select>
    </div>

    <div class="user-funnel-toolbar__field">
      <label for="search">Busca</label>
      <input
        id="search"
        type="text"
        class="admin-input"
        [(ngModel)]="search"
        (keydown.enter)="onApplyFilters()"
        placeholder="Username, nome, email ou gamer name" />
    </div>

    <div class="user-funnel-toolbar__actions">
      <button class="admin-btn admin-btn--primary" type="button" (click)="onApplyFilters()">Aplicar</button>
      <button class="admin-btn admin-btn--secondary" type="button" (click)="clearFilters()">Limpar</button>
    </div>
  </div>

  <div class="user-funnel-summary-grid">
    <article class="user-funnel-card admin-surface">
      <span>Cadastro</span>
      <strong>{{ summary.registration_count }}</strong>
    </article>
    <article class="user-funnel-card admin-surface">
      <span>Vínculo de Conta</span>
      <strong>{{ summary.link_count }}</strong>
      <small>{{ formatPercentage(summary.conversions.registration_to_link_percentage) }}</small>
    </article>
    <article class="user-funnel-card admin-surface">
      <span>Compra de Moedas</span>
      <strong>{{ summary.coin_purchase_count }}</strong>
      <small>{{ formatPercentage(summary.conversions.registration_to_coin_purchase_percentage) }}</small>
    </article>
    <article class="user-funnel-card admin-surface">
      <span>Batalha</span>
      <strong>{{ summary.battle_count }}</strong>
      <small>{{ formatPercentage(summary.conversions.registration_to_battle_percentage) }}</small>
    </article>
  </div>

  <div class="user-funnel-table-wrapper admin-surface">
    <p-table
      [value]="rows"
      [paginator]="true"
      [rows]="rowsPerPage"
      [totalRecords]="totalItems"
      [lazy]="true"
      [loading]="isLoading"
      (onLazyLoad)="onLazyLoad($event)">
      <ng-template pTemplate="header">
        <tr>
          <th>ID</th>
          <th>Usuário</th>
          <th>Email</th>
          <th>Plataformas</th>
          <th>Recorrente</th>
          <th>Compras de moedas</th>
          <th>Vínculo de conta</th>
          <th>Compra de moedas</th>
          <th>Batalha</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-user>
        <tr>
          <td>{{ user.id }}</td>
          <td>{{ user.username }}</td>
          <td>{{ user.email }}</td>
          <td>{{ formatPlatforms(user.linked_platforms) }}</td>
          <td>{{ user.is_recurring ? 'Sim' : 'Não' }}</td>
          <td>{{ user.coin_purchase_count }}</td>
          <td>{{ user.has_link_account ? 'Sim' : 'Não' }}</td>
          <td>{{ user.has_coin_purchase ? 'Sim' : 'Não' }}</td>
          <td>{{ user.has_battle ? 'Sim' : 'Não' }}</td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="9" class="user-funnel-table__empty-message">
            <div *ngIf="isLoading" class="user-funnel-empty-state">
              <p-progressSpinner ariaLabel="Carregando dados do funil" strokeWidth="6"></p-progressSpinner>
              <span>Carregando dados do funil...</span>
            </div>
            <div *ngIf="!isLoading" class="user-funnel-empty-state">
              <i class="pi pi-chart-line"></i>
              <span>Nenhum usuário encontrado para os filtros atuais.</span>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <p class="user-funnel-error" *ngIf="errorMessage">{{ errorMessage }}</p>
</section>
